import type { PropsWithChildren } from "react";
import { Element } from "react-scroll";

import type { ILenderApplicationExtended } from "@/features/lender-applications/types/lender-application";
import type { ILenderResponse } from "@/features/lender-responses/types/lender-response";

import { LenderResponse } from "./LenderResponse";

const BidsContainer = ({
  title,
  children,
}: PropsWithChildren<{ title: string }>) => {
  return (
    <section className="mb-7">
      <h1 className="mb-5 text-[1.5rem]">{title}</h1>

      <div className="flex flex-col gap-4">{children}</div>
    </section>
  );
};

interface BidsProps {
  lenderResponses: ILenderResponse[];
  title: string;
  lenderApplication: ILenderApplicationExtended;
}

const Bids = ({ lenderResponses, title, lenderApplication }: BidsProps) => {
  return (
    <Element name={`scrollToBidsList`}>
      <BidsContainer title={title}>
        {lenderResponses.map((item) => (
          <Element key={item.id} name={`scrollToLenderResponseId-${item.id}`}>
            <LenderResponse
              lenderResponse={item}
              lenderApplication={lenderApplication}
              preview={false}
            />
          </Element>
        ))}
      </BidsContainer>
    </Element>
  );
};

export default Bids;
